export default __webpack_public_path__ + "static/media/sao_logo.75400e9a.svg";